const formDataSchema ={
    feilds: [{
        id: 1,
        name: 'percentage',
        title: 'Bill Tracking (%)*',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0 && (value > 0)); //&& (value <= 100)
                },
                message: 'Please Enter Correct Percentage value'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3'
    }
    ]
}

const smsformDataSchema ={
    feilds: [{
        id: 1,
        name: 'exclude_departments',
        title: 'Exclude Departments*',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0); //&& (value <= 100)
                },
                message: 'Please Select Departments'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-12 mb-2 d-flex pr-1 pl-2'
    }
    ]
}
const icuDataSchema ={
    feilds: [{
        id: 1,
        name: 'include_departments',
        title: 'Include Departments*',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0); //&& (value <= 100)
                },
                message: 'Please Select Departments'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-12 mb-2 d-flex pr-1 pl-2'
    }
    ]
}
const emailDataSchema ={
    feilds: [{
        id: 1,
        name: 'emails',
        title: 'Emails',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'input',
        placeholder: 'Email',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0); //&& (value <= 100)
                },
                message: 'Please enter email id.'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-6 mb-2 d-flex pr-1 pl-2'
    },
    {
        id: 2,
        name: 'multiple_unit',
        title: 'Select Multiple Unit*',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Select Units',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0); //&& (value <= 100)
                },
                message: '*Please Select Atleast One Unit'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-6 mb-2 d-flex pr-1 pl-2'
    }
    ]
}

const checkListAddDataSchema ={
    feilds: [{
        id: 1,
        name: 'addchecklist',
        title: 'addchecklist',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'input',
        placeholder: 'Add CheckList',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0); //&& (value <= 100)
                },
                message: 'Please enter CheckList.'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-6 mb-2 d-flex pr-1 pl-2'
    },
    ]
}

const nmeListAddDataSchema ={
    feilds: [
        {
        id: 1,
        name: 'unit',
        title: 'Unit',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Unit'
            }
        ],
        errors: [],
        value: null,
        valid: true,
        state: '',
        disable: false,
        className: 'col-6 mb-2 d-flex pr-1 pl-2'
    },
    {
        id: 2,
        name: 'department',
        title: 'Department',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Department'
            }
        ],
        errors: [],
        value: null,
        valid: true,
        state: '',
        disable: false,
        className: 'col-6 mb-2 d-flex pr-1 pl-2'
    },
    {
        id: 3,
        name: 'tariff',
        title: 'tariff',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Select tariff',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Tariff'
            }
        ],
        errors: [],
        value: null,
        valid: true,
        state: '',
        disable: false,
        className: 'col-4'
    },
    {
        id: 4,
        name: 'description',
        title: 'Description',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'input',
        placeholder: 'Add Description',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0); //&& (value <= 100)
                },
                message: 'Please enter description'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-6 mb-2 d-flex pr-1 pl-2'
    },
    {
        id: 5,
        name: 'rate',
        //title: 'Number of Breaks*',
        visible: false,
        element: 'input',
        //suffix: "Times",
        required: true,
        input_type: 'number',
        placeholder: 'Rate',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value && value > 0);
                },
                message: 'Please enter Rate'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-6 mb-2 d-flex pr-1 pl-2'
      },
    ]
}

// const nmeDataSchema ={
//     feilds: [
//         {
//         id: 1,
//         name: 'unit',
//         title: 'Unit',
//         visible: true,
//         element: 'select2',
//         required: true,
//         input_type: 'select',
//         placeholder: 'Select',
//         icon: 'user',
//         rules: [
//             {
//                 test: (value) => {
//                     return (value !== null && value.length > 0);
//                 },
//                 message: 'Please Select Unit'
//             }
//         ],
//         errors: [],
//         value: null,
//         valid: true,
//         state: '',
//         disable: false,
//         className: 'col-4'
//     },
//     {
//         id: 2,
//         name: 'department',
//         title: 'Department',
//         visible: true,
//         element: 'select2',
//         required: true,
//         input_type: 'select',
//         placeholder: 'Select',
//         icon: 'user',
//         rules: [
//             {
//                 test: (value) => {
//                     return (value !== null && value.length > 0);
//                 },
//                 message: 'Please Select Department'
//             }
//         ],
//         errors: [],
//         value: null,
//         valid: true,
//         state: '',
//         disable: false,
//         className: 'col-4'
//     },
//     {
//         id: 3,
//         name: 'tariff',
//         title: 'tariff',
//         visible: true,
//         element: 'select2',
//         required: true,
//         input_type: 'select',
//         placeholder: 'Select',
//         icon: 'user',
//         rules: [
//             {
//                 test: (value) => {
//                     return (value !== null && value.length > 0);
//                 },
//                 message: 'Please Select Tariff'
//             }
//         ],
//         errors: [],
//         value: null,
//         valid: true,
//         state: '',
//         disable: false,
//         className: 'col-4'
//     },
//     {
//         id: 4,
//         name: 'description',
//         title: 'Description',
//         visible: true,
//         element: 'input',
//         required: true,
//         input_type: 'input',
//         placeholder: 'Add CheckList',
//         icon: 'user',
//         rules: [
//             {
//                 test: (value) => {
//                     return (value !== null && value.length > 0); //&& (value <= 100)
//                 },
//                 message: 'Please enter CheckList.'
//             }
//         ],
//         errors: [],
//         value: null,
//         valid: false,
//         state: '',
//         disable: false,
//         className: 'col-6 mb-2 d-flex pr-1 pl-2'
//     },
//     {
//         id: 5,
//         name: 'rate',
//         //title: 'Number of Breaks*',
//         visible: false,
//         element: 'input',
//         //suffix: "Times",
//         required: true,
//         input_type: 'number',
//         placeholder: 'Rate',
//         icon: 'user',
//         rules: [
//             {
//                 test: (value) => {
//                     return (value && value > 0);
//                 },
//                 message: 'Please enter Rate'
//             }
//         ],
//         errors: [],
//         value: null,
//         valid: false,
//         state: '',
//         disable: false,
//         className: 'col-6 mb-2 d-flex pr-1 pl-2'
//       },
//     ]
// }

const breaksDataSchema ={
    feilds: [{
        id: 1,
        name: 'break_time',
        title: 'Break Duration (min)*',
        visible: true,
        element: 'input',
        suffix: "min",
        required: true,
        input_type: 'number',
        placeholder: 'Break Duration',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value && value > 0); 
                },
                message: 'Please enter break duration.'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-6 mb-2 d-flex pr-1 pl-2'
      }, 
      {
        id: 1,
        name: 'number_of_breaks',
        title: 'Number of Breaks*',
        visible: true,
        element: 'input',
        suffix: "Times",
        required: true,
        input_type: 'number',
        placeholder: 'Number of Breaks',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value && value > 0);
                },
                message: 'Please enter number of breaks.'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-6 mb-2 d-flex pr-1 pl-2'
      },
    ]
}

const checklistDataSchema ={
    feilds: [{
        id: 1,
        name: 'checklist',
        title: 'checklist',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'input',
        placeholder: 'Add CheckList',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0); //&& (value <= 100)
                },
                message: 'Please enter CheckList.'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-6 mb-2 d-flex pr-1 pl-2'
    },
    ]
}

const nmelistDataSchema ={
    feilds: [
        {
        id: 1,
        name: 'unit',
        title: 'Unit',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Unit'
            }
        ],
        errors: [],
        value: null,
        valid: true,
        state: '',
        disable: false,
        className: 'col-4'
    },
    {
        id: 2,
        name: 'department',
        title: 'Department',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Department'
            }
        ],
        errors: [],
        value: null,
        valid: true,
        state: '',
        disable: false,
        className: 'col-4'
    },
    {
        id: 3,
        name: 'tariff',
        title: 'Tariff',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Tariff'
            }
        ],
        errors: [],
        value: null,
        valid: true,
        state: '',
        disable: false,
        className: 'col-4'
    },
    {
        id: 4,
        name: 'description',
        title: 'Description',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'input',
        placeholder: 'Add Description',
        icon: 'user',
        // rules: [
        //     {
        //         test: (value) => {
        //             return (value !== null && value.length > 0); //&& (value <= 100)
        //         },
        //         message: 'Please enter Description'
        //     }
        // ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-6 mb-2 d-flex pr-1 pl-2'
    },
    {
        id: 5,
        name: 'rate',
        //title: 'Number of Breaks*',
        visible: false,
        element: 'input',
        //suffix: "Times",
        required: true,
        input_type: 'number',
        placeholder: 'Rate',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value && value > 0);
                },
                message: 'Please enter Rate'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-6 mb-2 d-flex pr-1 pl-2'
      },
    ]
}
export {formDataSchema, smsformDataSchema,icuDataSchema, emailDataSchema, breaksDataSchema, checklistDataSchema, checkListAddDataSchema, nmeListAddDataSchema, nmelistDataSchema};